export const serviceSliderText = {
  individuals: {
    header: "Looking for more structure?",
    subHeader:
      "Contact Us today and learn more about our Integrated Arabic Curriculum for Beginners. Developed in partnership with the Head of the Arabic Department at Cornell University, this program is completely unique, based on the textbook Arabiyyat al-Naas and integrates colloquial Arabic with Modern Standard Arabic (MSA) in a way that reflects the use of the language by native speakers",
  },
  academic: {
    header: "Latest News & Learning Advice",
    subHeader: undefined,
  },
};

export const serviceSliderImages = [
  {
    title: "img-1",
    image:
      "https://images.unsplash.com/photo-1537000092872-06bbf7b64f60?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=14d2fe1244b43a1841569da918066fc4&auto=format&fit=crop&w=1050&q=80",
  },
  {
    title: "img-2",
    image:
      "https://images.unsplash.com/photo-1499155286265-79a9dc9c6380?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=662&q=80",
  },
  {
    title: "img-3",
    image:
      "https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=668&q=80",
  },
];

export const individualsTestimonialsText = {
  header: "What Our Learners Say",
  subHeader:
    "Hear the impact that signing up to NaTakllam has had in the lives of some of our learners. ",
};

export const organizationsTestimonialsText = {
  header: "What Organizations Are Saying",
  subHeader: undefined,
};

export const academicTestimonialsText = {
  header: "What Our School & University Partners Say",
  subHeader:
    "Our Partners love the impact and learning that NaTakallam brings to your classroom or campus. ",
};

export const individualsTestimonialsCardData = [
  {
    person: "Bertram Jensen",
    msg:
      "Musicians, actors and influencers plan social media takeover to support #MarchForOurLives",
    info: "Author at Panoply Store",
    avatar: "/static/images/avatar/1.jpg",
  },
  {
    person: "Bertram Jensen",
    msg:
      "Musicians, actors and influencers plan social media takeover to support #MarchForOurLives",
    info: "Author at Panoply Store",
    avatar: "/static/images/avatar/1.jpg",
  },
  {
    person: "Bertram Jensen",
    msg:
      "Musicians, actors and influencers plan social media takeover to support #MarchForOurLives",
    info: "Author at Panoply Store",
    avatar: "/static/images/avatar/1.jpg",
  },
];

export const organizationsTestimonialsCardData = [
  {
    person: "Bertram Jensen",
    msg: "Doing a virtual session in our office was truly impactful! ",
    info: "Pennsylvania",
    avatar: "/static/images/avatar/1.jpg",
  },
  {
    person: "Bertram Jensen",
    msg: "Doing a virtual session in our office was truly impactful! ",
    info: "Pennsylvania",
    avatar: "/static/images/avatar/1.jpg",
  },
  {
    person: "Bertram Jensen",
    msg: "Doing a virtual session in our office was truly impactful! ",
    info: "Pennsylvania",
    avatar: "/static/images/avatar/1.jpg",
  },
];

export const academicTestimonialsCardData = [
  {
    person: "Vasilki D, Teacher",
    msg:
      "“Tarek was a fantastic speaker and everyone was inspired by his resilience and perseverance. More refugee voices need to be heard in this country.” ",
    info: "Pennsylvania",
    avatar: "/static/images/avatar/1.jpg",
  },
  {
    person: "Javier Hill, Teacher",
    msg:
      "“This great learning opportunity will enhance my students’ understanding of what refugees or displaced people go through and will help them create their own perspective. It will hopefully help them take action and advocate for them.” ",
    info: "Chapel Hill, NC",
    avatar: "/static/images/avatar/1.jpg",
  },
  {
    person: "Rana Abdul-Aziz, Professor",
    msg:
      "“Tarek was a fantastic speaker and everyone was inspired by his resilience and perseverance. More refugee voices need to be heard in this country.” ",
    info: "Pennsylvania",
    avatar: "/static/images/avatar/1.jpg",
  },
];

export const academicData = {
  header: "What We Offer",
  paragraph:
    "Thousands of students at 100+ schools worldwide have used NaTakallam for powerful, empathy-building sessions that foster global citizenship.",
  cardData: [
    {
      id: "language-practise",
      header: "Language Practice",
      paragraph:
        "Integrate one-on-one online sessions into your existing language course. Each student is paired with a conversation partner for practice outside the classroom. Conversation partners work with professors to craft sessions that support their curriculum.",
      image: "https://placekitten.com/640/360",
    },
    {
      id: "cultural-exchange",
      header: "Cultural Exchange",
      paragraph:
        "Go beyond the headlines and the statistics to discover the lives and perspectives of displaced people. Integrate a series of one-on-one online dialogue sessions into courses related to human rights, refugee studies, or other relevant subjects.",
      image: "https://placekitten.com/640/360",
    },
    {
      id: "refugee-voices",
      header: "Refugee Voices",
      paragraph:
        "Amplify refugee voices with a one-time group session that invites a NaTakallam conversation partner to videoconference into any campus event for Q&A and discussion regarding the impact of displacement of their lives. Sessions can take place in English or any of our other offered languages.",
      image: "https://placekitten.com/640/360",
    },
  ],
};

export const organizationsData = {
  header:
    "Amplify refugee voices with a one-of-a-kind experience in your office or community.",
  paragraph: "",
  cardData: [
    {
      id: "customized",
      header: "Customized",
      paragraph:
        "Each session with a Conversation Partners is customized to suit the needs of your team.",
      image: "https://placekitten.com/640/360",
    },
    {
      id: "virtual",
      header: "Virtual Guest Speakers",
      paragraph:
        "Bring your team together beyond one on one language sessions and bring the voices of the displaced to your office your community and beyond.",
      image: "https://placekitten.com/640/360",
    },
    {
      id: "impactful",
      header: "Impactful",
      paragraph:
        "Each team or individual session you do goes directly towards supporting refugee livelihoods.",
      image: "https://placekitten.com/640/360",
    },
  ],
};

export const individualsData = {
  header: "Why NaTakallam",
  paragraph:
    "We deliver award-winning tailored language learning services for professionals, taught by expert refugee conversation partners.",
  cardData: [
    {
      id: "find-couch",
      header: "Find the perfect language coach",
      paragraph:
        "We match learners with a language coach who shares their professional background and interests to unlock their global potential. ",
      image: "https://placekitten.com/640/360",
    },
    {
      id: "maintaine-motivation",
      header: "Maintain your motivation!",
      paragraph:
        "Our  Arabic language curriculum achieves industry-topping course completion rates by putting the human element of learning back where it should be: front and centre. ",
      image: "https://placekitten.com/640/360",
    },
    {
      id: "have-impact",
      header: "Have an impact",
      paragraph:
        "Our language coaches are professionals from industries spanning engineering, art, and business. While our students learn, our coaches earn a living and regain their professional dignity. ",
      image: "https://placekitten.com/640/360",
    },
  ],
};
export const individualsHIWData = {
  header: "How It Works",
  paragraph:
    "NaTakallam offers online conversation sessions with vetted refugee conversation partners in Arabic, Spanish, French and Persion. What are you waiting for? Sign up today in three easy steps! ",
  cardData: [
    {
      id: "step-one-i",
      header: "Step One",
      paragraph: "Register your interest here. ",
    },
    {
      id: "step-two-i",
      header: "Step Two",
      paragraph:
        "Purchase your preferred bundle of sessions. We have bundles starting from only one hour.",
    },
    {
      id: "step-three-i",
      header: "Step Three",
      paragraph:
        "Be on the look out for an email introduction and meet your conversation partner. ",
    },
  ],
};

export const translationCardData = {
  header: "Services Available",
  paragraph:
    "NaTakallam offers professional translation and transcription services delivered by qualified refugees, overseen by certified copy editors, proofreaders and project managers. ",
  cardData: [
    {
      id: "website-t",
      header: "Website and App Translation",
      paragraph:
        "Three Rings for the Elven-kings under the sky, Seven for the Dwarf-lords in halls of stone.",
      image: "https://placekitten.com/640/360",
    },
    {
      id: "document-t",
      header: "Document Translation",
      paragraph:
        "Three Rings for the Elven-kings under the sky, Seven for the Dwarf-lords in halls of stone",
      image: "https://placekitten.com/640/360",
    },
    {
      id: "audio",
      header: "Audio Transcription & Translation",
      paragraph:
        "Three Rings for the Elven-kings under the sky, Seven for the Dwarf-lords in halls of stone",
      image: "https://placekitten.com/640/360",
    },
  ],
};
export const translationHIWData = {
  header: "How It Works",
  paragraph:
    "NaTakallam offers English to and from Arabic, French, Kurdish, Pashto, Persian (Farsi/Dari), Portuguese, Somali, Spanish, Tigrinya, Turkish, Urdu. ",
  cardData: [
    {
      id: "step-one-t",
      header: "Step One",
      paragraph: "We’ll provide you with a quote within 1-2 business days. ",
    },
    {
      id: "step-two-t",
      header: "Step Two",
      paragraph:
        "Three Rings for the Elven-kings under the sky, Seven for the Dwarf-lords in halls of stone",
    },
    {
      id: "step-three-t",
      header: "Step Three",
      paragraph:
        "Be on the look out for an email introduction from a vetted translator. ",
    },
  ],
};
export const translationBottomData = {
  person: "Emily Jørgensen",
  msg:
    "Currently, Ford sells six sedans and coupes in North America with the Fiesta, Focus, Fusion, C-Max, Mustang and Taurus. This lineup hits.",
  avatar: "https://placekitten.com/640/360",
  job: "Author at Panoply Store",
};

export const trustedByData = {
  header: "Trusted By",
  paragraph:
    "We are trusted by some of the world’s leading schools and universities that integrate NaTakallam into their courses and campuses!",
  images: [
    {
      title: "img0",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img1",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img2",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img3",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img4",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img5",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img6",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img7",
      image: "https://placekitten.com/640/360",
    },
  ],
};
export const trustedByHomeData = {
  header: "Trusted By",
  paragraph: "We are trusted by some of the world’s leading organizations",
  images: [
    {
      title: "img0",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img1",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img2",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img3",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img4",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img5",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img6",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img7",
      image: "https://placekitten.com/640/360",
    },
  ],
};
export const featuredInHomeData = {
  header: "Featured In",
  paragraph:
    "NaTakkalam has been featured in leading media publications around the world.",
  images: [
    {
      title: "img0",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img1",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img2",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img3",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img4",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img5",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img6",
      image: "https://placekitten.com/640/360",
    },
    {
      title: "img7",
      image: "https://placekitten.com/640/360",
    },
  ],
};
export const readyStartData = {
  header: "Ready to start learning?",
  paragraph:
    "Learn how NaTakallam can create or improve your organisation’s language learning programme or buy it for yourself.",
  title: "Button",
};
